export default __webpack_public_path__ + "static/media/Well done.e2949887.svg";